var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "btnList",
    class: {
      'screen-optimization': _vm.isScreenOptimization
    }
  }, _vm._l(_vm.btnList, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.type,
        expression: "item.type"
      }],
      key: index,
      ref: item.type,
      refInFor: true,
      staticClass: "btnItem",
      class: _vm.btnClass(item.type),
      attrs: {
        "item": item
      },
      on: {
        "click": function ($event) {
          return item.handler(item);
        }
      }
    }, [_c('div', {
      staticClass: "top-icon",
      class: `${item.type}-icon`
    }), _c('span', {
      staticClass: "text bottom-text"
    }, [_vm._v(_vm._s(item.text))])]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };